import { Button } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import styled from 'styled-components'

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  gap: 8px;
`

interface CompensationMatrixAnalysisLastConfigurationModalFooterProps {
  onClose: () => void
}

const CompensationMatrixAnalysisLastConfigurationModalFooter = memo(
  ({
    onClose,
  }: CompensationMatrixAnalysisLastConfigurationModalFooterProps) => {
    return (
      <Footer>
        <Button key="close" onClick={onClose} type="text">
          {t('Close')}
        </Button>
      </Footer>
    )
  }
)

export default CompensationMatrixAnalysisLastConfigurationModalFooter
